import { BookingLogDataType } from '@collinsonx/utils/lib/analytics';
import {
  AnalyticsFunctionProps,
  sendActionLog,
  sendErrorLog,
  sendInfoLog,
  sendWarnLog,
} from '@lib/logging';
import { BookingError, BookingInfo, BookingWarn } from 'config/datadog';
import { BookingContext } from 'context/BookingContext';
import { useContext } from 'react';

import usePayload from './usePayload';
import useProduct from './useProduct';

const useAnalytics = () => {
  const { booking } = useContext(BookingContext);
  const { consumerData, linkedAccountId, payload } = usePayload();
  const { productID } = useProduct();

  // TODO: import bookingStatus from the useBooking hook once its implemented (https://lifestyle-x.atlassian.net/browse/BAAS-1487)

  const getLogData = {
    bookingID: booking.bookingId ?? '',
    bookingReference: booking.reference ?? '',
    bookingStatus: '',
    consumerID: consumerData?.getConsumerByID.id ?? '',
    linkedAccountID: linkedAccountId ?? '',
    membershipID: payload?.membershipNumber ?? '',
    productID: productID ?? '',
  };

  const logInfo = (key: BookingInfo, data?: BookingLogDataType) => {
    sendInfoLog(key, {
      ...getLogData,
      ...data,
    });
  };

  const logWarn = (key: BookingWarn, data?: BookingLogDataType) => {
    sendWarnLog(key, {
      ...getLogData,
      ...data,
    });
  };

  const logError = (key: BookingError, data?: BookingLogDataType) => {
    sendErrorLog(key, {
      ...getLogData,
      ...data,
    });
  };

  const logCustomError = (error: Error, data?: BookingLogDataType) => {
    sendErrorLog(BookingError.UNEXPECTED_ERROR, {
      ...getLogData,
      ...data,
      message: error.message,
    });
  };

  const logAction = (props: AnalyticsFunctionProps) => {
    sendActionLog(props);
  };

  return {
    logAction,
    logCustomError,
    logError,
    logInfo,
    logWarn,
  };
};

export default useAnalytics;
